import Global from '../scripts/Global'
import UserSessionManager from './Session/Users.manager';
import ChannelSessionManager from './Session/Channels.manager';
import UserApi from '../scripts/api/user.api';
import VueSignals from '../scripts/VueSignals';



let BrokenUploads = []
let oSearch = null
let current_view = 'Chat'
let arrBroadCastUsersIds  = []


export default class SessionManager {
    constructor(){}

    /**
     *
     * @param {String} data JSON response from API
     */
    static createChannel(data){
        return ChannelSessionManager.CreateChannel(data)
    }
    static setInvitations(data){
        return ChannelSessionManager.setInvitations(data)
    }
    static UpdateExternalChannel(data){
        ChannelSessionManager.UpdateExternalChannel(data)
    }

    static CreatePublishedInvitation(data){
        ChannelSessionManager.CreatePublishedInvitation(data)
    }

    static createUser(data){
        UserSessionManager.CreateUser(data)
    }

    static createUserByID(user_id){
        UserSessionManager.createUserByID(user_id)
    }

    static isLoggedInUser(){
        return UserSessionManager.IsLoggedIn()
    }

    static setLoggedInUser(oUserData){
        UserSessionManager.SetLoggedInUser(oUserData)
    }

    static setFirstChannelActive(){
        SessionManager.setActiveChannel(ChannelSessionManager.GetAllChannels()[0])
    }

    static setActiveChannel(channel){
        ChannelSessionManager.SetActiveChannel(channel)
    }

    static setActivePossibleChannel(channel){
        ChannelSessionManager.SetActivePossibleChannel(channel)
    }

    static setActiveChannelById(channel_id){
        ChannelSessionManager.SetActiveChannelById(channel_id)
    }


    static createAllUsersCall(cpids){
       return  ChannelSessionManager.GetAllUsersApi(cpids)
    }

    static removeActiveChannel(){
        ChannelSessionManager.RemoveActiveChannel()
    }


    static removeChannel(channel_id){
       ChannelSessionManager.RemoveChannel(channel_id)
    }


    static setBroadCastingUsers(user_ids){
        arrBroadCastUsersIds = user_ids
    }

    static acceptInvitation(channel_data){
        ChannelSessionManager.AcceptInvitation(channel_data)
    }

    static declineInvitation(channel_id, user_ids){
        ChannelSessionManager.DeclineInvitation(channel_id, user_ids)
    }

    static DestroyChannel(cpid){
        ChannelSessionManager.DestroyChannel(cpid)
    }


    static AddPost(data){
        ChannelSessionManager.AddPost(data)
    }

    static DeletePost(psot_id){
        return ChannelSessionManager.DeletePost(psot_id)
    }

    static EditPost(post_id, new_message, files){
        return ChannelSessionManager.EditPost(post_id, new_message, files)
    }

    static UpdateChannel(channel_id, data){
        ChannelSessionManager.UpdateChannel(channel_id, data)
    }

    static UpdateChannelPicture(channel_id, image_doc){
        ChannelSessionManager.UpdateChannelPicture(channel_id, image_doc)
    }

    static SetReadStatus(status){
        ChannelSessionManager.SetReadStatus(status)
    }


    static addUsertoChannel(channel_id, user){
        ChannelSessionManager.AddUserToChannel(channel_id, user)
    }


    static setUserBrokenUploads(data){
        BrokenUploads = data
    }


    static setActiveSearch(search){
        oSearch = search
    }

    static setView(view){
        current_view = view
        if(current_view != 'Chat'){
            Global.globalValue(VueSignals.ACTIVE_CHANNEL_CHANGED_SIGNAL, true)
            Global.globalValue('active_channel_id', '')
        }
    }

    static SetBotId(user_id){
        UserApi.getUsers([user_id]).then(res => {
            if(res.data.result){
                UserSessionManager.SetBot(res.data.user[0])
            }
        })
    }


    static UpdateUserReachability(user_id, statue){
        UserSessionManager.SetUserReachability(user_id, statue)
    }

    static UpdateDirectMessageReachability(user_id, statue){
        ChannelSessionManager.UpdateDirectMessageReachability(user_id, statue)
    }

    static UpdateDirectMessageName(cp_id, new_name){
        ChannelSessionManager.UpdateDirectMessageName(cp_id, new_name)
    }

    static UpdateDirectMessageNameWithUserId(user_id, new_name){
        ChannelSessionManager.UpdateDirectMessageNameWithUserId(user_id, new_name)
    }

    static setLoggedinUserFolderRights(rights){
        UserSessionManager.SetLoggedinUserFolderRights(rights)
    }


    static ActivateDraftChannel(){
        ChannelSessionManager.ActivateDraftChannel()
    }

    static OverrideActiveChannel(channel_doc, first_unread_post_sqn){
        return ChannelSessionManager.SetActiveChannelDetails(channel_doc, first_unread_post_sqn)
    }

    static clear(){
        ChannelSessionManager.Clear()
        UserSessionManager.Clear()
        BrokenUploads = []
        oSearch = null
        current_view = 'Chat'
        arrBroadCastUsersIds  = []
    }

    static UpdateUser(data){
      UserSessionManager.UpdateUser(data)
    }

    static RemoveUserFromChannel(channel_id, user_id){
        ChannelSessionManager.RemoveUserFromChannel(channel_id, user_id)
    }


    static PostsCall(start_at = null, direction = "down"){
        return ChannelSessionManager.PostsCall(start_at, direction)
    }

    static MarkAllPostsRead(){
        return ChannelSessionManager.MarkAllPostsRead()
    }

    static MarkPostsRead(post_ids){
        return ChannelSessionManager.MarkPostsRead(post_ids)
    }


    static getChannel(cid){
        return ChannelSessionManager.GetChannel(cid)
    }

    static GetPublishedInvitation(){
        return ChannelSessionManager.GetPublishedInvitations()
    }

    static getChannels(){
        return ChannelSessionManager.GetAllChannels()
    }


    static getActiveChannelOnlineUsers(){
        return ChannelSessionManager.GetActiveChannelOnlineUsers()
    }


    static getActiveChannelOnlineUsersIds(){
        let users = ChannelSessionManager.GetActiveChannelOnlineUsers()
        let user_ids = []

        for(let i=0; i < users.length;i++){
            user_ids.push(users[i].user_id)
        }

        return user_ids
    }

    static getUsers(){
        return UserSessionManager.GetUsers()
    }

    static GetActiveChannelUserIds(){
        return ChannelSessionManager.GetActiveChannelUserIds()
    }

    static getUserBrokenUploads(){
        return BrokenUploads
    }

    static getLoggedinUserFolderRights(){
        return UserSessionManager.getLoggedinUserFolderRights()
    }


    static getActiveChannelUser(user_id){
       return ChannelSessionManager.GetActiveChannelUser(user_id)
    }


    static getFirstChannel(){
        return this.getChannels()[0]
    }


    static GetActiveChannelUsers(){
        return ChannelSessionManager.GetActiveChannelUsers()
    }


    static getUser(user_id){
       return UserSessionManager.GetUser(user_id)
    }

    static makeUserCall(user_id){
        return UserSessionManager.MakeUserCall(user_id)
     }

    static getUserByEmail(user_email){
        return UserSessionManager.GetUserByEmail(user_email)
     }

    static getActiveChannelUsers(){
        return ChannelSessionManager.GetActiveChannelUsers()
    }

    static getLoggedInUserId(){
        return UserSessionManager.GetLoggedInUserId()
    }


    static getLoggedInUser(){
        return UserSessionManager.GetLoggedInUserDoc()
    }


    static getActiveChannel(){
        return ChannelSessionManager.GetActiveChannel()
    }

    static getActiveChannelId(){
        return ChannelSessionManager.GetActiveChannelId()
    }

    static getBroadCastUsersIds(){
        return arrBroadCastUsersIds
    }

    static getActiveSearch(){
        return oSearch
        //@Warning TailSearchPost
    }

    static GetPosts(){
        return ChannelSessionManager.GetPosts()
    }

    static GetPostDates(){
        return ChannelSessionManager.GetPostDates()
    }

    static getView(){
        return current_view
    }

    static ClearPosts(){
        return ChannelSessionManager.ClearPosts()
    }

    static setChannelsLastMessage(channels_ids){
        return ChannelSessionManager.setChannelsLastMessage(channels_ids);
    }

    static updateDirectChannelPicture(user_id, url){
        return ChannelSessionManager.updateDirectChannelPicture(user_id, url);
    }

    static updateChannelsUnreadMessages(){
        return ChannelSessionManager.updateChannelsUnreadMessages();
    }
}
